const DEDICATION_TYPES = ['in_honor_of', 'in_memory_of'];

export { DEDICATION_TYPES };
